module.exports = __webpack_public_path__ + "static/media/documents.62b94b74.svg";